import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AuditService = {
  apply: async (payload) => axios.post(`${API_URL}/audit/apply`, payload).then(({data}) => data).catch((err) => { throw err })
};

export default AuditService;